'use strict';

import UserService from './UserService';

export var service = new UserService();